import Vue from 'vue'
import Router from 'vue-router'
import { resolve } from 'url';
import { request } from 'http';

Vue.use(Router)

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			component: resolve => require(['@/views/layout'],resolve),
			redirect: '/page',
			children: [
				{
					path: 'page',
					name: 'page',
					component: resolve => require(['@/views/page'],resolve)
				},
				{
					path: 'step-one',
					name: 'step-one',
					component: resolve => require(['@/views/step-one'],resolve)
				},
				{
					path: 'step-two',
					name: 'step-two',
					component: resolve => require(['@/views/step-two'],resolve)
				},
				{
					path: 'step-three',
					name: 'step-three',
					component: resolve => require(['@/views/step-three'],resolve)
				},
				{
					path: 'step-four',
					name: 'step-four',
					component: resolve => require(['@/views/step-four'],resolve)
				},
				{
					path: 'step-five',
					name: 'step-five',
					component: resolve => require(['@/views/step-five'],resolve)
				},
				{
					path: 'step-six',
					name: 'step-six',
					component: resolve => require(['@/views/step-six'],resolve)
				},
				{
					path: 'phone',
					name: 'phone',
					component: resolve => require(['@/views/phone'],resolve)
				},
				{
					path: 'back-tis',
					name: 'back-tis',
					component: resolve => require(['@/views/back-tis'],resolve)
				},
				{
					path: 'resume',
					name: 'resume',
					component: resolve => require(['@/views/resume'],resolve)
				},
				{
					path: 'weixin',
					name: 'weixin',
					component: resolve => require(['@/views/weixin'],resolve)
				},
				{
					path: 'protocol',
					name: 'protocol',
					component: resolve => require(['@/views/protocol'],resolve)
				}
			]
		},
		{
			path: '/m',
			component: resolve => require(['@/views/index'],resolve),
			redirect: '/m/home',
			children: [
				{
					path: 'home',
					name: 'home',
					component: resolve => require(['@/views/home'],resolve)
				},
				{
					path: 'special',
					name: 'special',
					component: resolve => require(['@/views/special'],resolve)
				},
				{
					path: 'msg',
					name: 'msg',
					component: resolve => require(['@/views/msg'],resolve)
				},
				{
					path: 'me',
					name: 'me',
					component: resolve => require(['@/views/me'],resolve)
				}
			]
		},
		{
			path: '/download',
			name: 'download',
			component: resolve => require(['@/views/download'],resolve)
		},
		{
			path: '/download-2',
			name: 'download-2',
			component: resolve => require(['@/views/download-2'],resolve)
		},
		{
			path: '/download-3',
			name: 'download-3',
			component: resolve => require(['@/views/download-3'],resolve)
		},,
		{
			path: '/download-4',
			name: 'download-4',
			component: resolve => require(['@/views/download-4'],resolve)
		},
		{
			path: '*',
			component: resolve => require(['@/views/404'],resolve)
		}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js